module.exports = __webpack_public_path__ + "img/1548233582.5438649d.jpg";